import { IToastOptions } from "devextreme-react/toast";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
import MdaeToast from "./component";
export interface IMdaeToastProps extends IToastOptions {
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export const toastDefaultConfig: IToastOptions = {
  position: { my: "top", at: "top" },
  displayTime: 4000,
};
export default MdaeToast;
